import { observer } from "mobx-react";
import React from "react";
import { Text, rem, Title, ActionIcon, Box, Group, Paper } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { IconEdit } from "@tabler/icons-react";
import { MODALS } from "../../helpers/constants";
import TopRightInfoCircle from "../dataDisplay/topRightInfoCircle";

const NodeAlias = observer(({ cubby }: { cubby: Cubby }) => {
  const knownAlias =
    cubby.alias ||
    cubby.cubbyInfo?.data?.alias ||
    (cubby?.publicKey ? cubby.publicKey.slice(0, 8) : null) ||
    "pending...";

  return (
    <>
      <Paper withBorder style={{ position: "relative" }} p="md" radius="md">
        {/* <TopRightInfoCircle infoLink="docs.megalithic.me" /> */}
        <Title order={4}>
          {knownAlias}
          {cubby.allowOnchainActions && (
            <ActionIcon
              size="sm"
              variant="default"
              aria-label="Edit Alias"
              onClick={() => cubby.setModal(MODALS.CHANGE_ALIAS)}
              style={{ marginLeft: rem(8) }}
            >
              <IconEdit />
            </ActionIcon>
          )}
        </Title>

        <Text c="dimmed" size="xs">
          node alias
        </Text>
      </Paper>
    </>
  );
});

export default NodeAlias;
